// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OutOfOrderAssetRequestDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';
import { map } from 'rxjs';

@Injectable()
export class OutOfOrderAssetRequestApiClient extends BaseCRUDApiClient<OutOfOrderAssetRequestDto> {
  baseUrl = this.config.apiEndpoint + '/out-of-order-asset-request';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }

  createDocument(id: string) {
    return this.http
      .post(
        `${this.baseUrl}/create-document`,
        { id: id },
        {
          responseType: 'arraybuffer',
        },
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        }),
      );
  }

  saveAndAttachDocument(id: string) {
    return this.http.post(`${this.baseUrl}/save-and-attach-document`, {
      id: id,
    });
  }
}
